export default __webpack_public_path__ + "static/media/VO_ServicesTriangles_1.ec051e84.png";